import script from "./CaskComplexTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskComplexTable.vue?vue&type=script&setup=true&lang=js"

import "./CaskComplexTable.vue?vue&type=style&index=0&id=674751b4&lang=scss"

const __exports__ = script;

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QCheckbox,QBtn,QIcon,QPopupProxy,QPagination,QTd,QImg,QSpinner});
